import { FC, SVGProps, createElement } from 'react';

import { ReactComponent as DumbbellSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/dumbbell.svg';
import { ReactComponent as KettlebellSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/kettlebell.svg';
import { ReactComponent as BarbellSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/barbell.svg';
import { ReactComponent as BenchSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/bench.svg';
import { ReactComponent as CrunchBenchSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/crunch_bench.svg';
import { ReactComponent as AbsCrunchMachineSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/abs_crunch_machine.svg';
import { ReactComponent as ChestPressSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/chest_press.svg';
import { ReactComponent as FitnessBallSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/fitness_ball.svg';
import { ReactComponent as FoamRollerSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/foam_roller.svg';
import { ReactComponent as HipAbductionSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/hip_abduction.svg';
import { ReactComponent as HipAdductionSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/hip_adbuction_2.svg';
import { ReactComponent as JumpRopeSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/jump_rope.svg';
import { ReactComponent as LatPullDownSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/lat_pull_down.svg';
import { ReactComponent as LegCurlSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/leg_curl.svg';
import { ReactComponent as LegExtensionSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/leg_extension.svg';
import { ReactComponent as LegPressSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/leg_press.svg';
import { ReactComponent as CableCrossoverSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/cable_crossover.svg';
import { ReactComponent as PulleyMachineSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/pulley_machine.svg';
import { ReactComponent as SeatedRowMachineSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/seated_row_machine.svg';
import { ReactComponent as ShoulderPressSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/shoulder_press.svg';
import { ReactComponent as TricepsDipMachineSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/triceps_dip_machine.svg';
import { ReactComponent as YogaMatSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/yoga_mat.svg';
import { ReactComponent as BodyweightSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/bodyweight.svg';
import { ReactComponent as PullUpBarSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/pull_up_bar.svg';
import { ReactComponent as ResistanceBandSvg } from 'src/assets/images/onboarding-trainer/equipment/svg/resistance_band.svg';
import { ReactComponent as OtherSvg } from 'src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg';

export const EQUIPMENT_ICON_MAP: Record<string, FC<SVGProps<SVGSVGElement>>> = {
  // Dumbbell
  dumbell: DumbbellSvg,
  dumbbell: DumbbellSvg,

  // Kettlebell
  kettlebell: KettlebellSvg,

  // Barbell
  barbell: BarbellSvg,

  // Bench
  bench: BenchSvg,

  // Crunch bench
  crunch_bench: CrunchBenchSvg,
  'crunch-bench': CrunchBenchSvg,

  // Abs crunch machine
  abs_crunch_machine: AbsCrunchMachineSvg,
  'abs-crunch-machine': AbsCrunchMachineSvg,

  // Chest press
  chest_press: ChestPressSvg,
  'chest-press': ChestPressSvg,

  // Fitness ball
  fitness_ball: FitnessBallSvg,
  'fitness-ball': FitnessBallSvg,
  swiss_ball: FitnessBallSvg,
  'swiss-ball': FitnessBallSvg,

  // Foam roller
  foam_roller: FoamRollerSvg,
  'foam-roller': FoamRollerSvg,

  // Hip abduction
  hip_abduction: HipAbductionSvg,
  'hip-abduction': HipAbductionSvg,
  hip_adbuction: HipAbductionSvg,
  'hip-adbuction': HipAbductionSvg,

  // Hip adduction
  hip_adbuction_2: HipAdductionSvg,
  'hip-adbuction-2': HipAdductionSvg,
  hip_adduction: HipAdductionSvg,
  'hip-adduction': HipAdductionSvg,

  // Jump rope
  jump_rope: JumpRopeSvg,
  'jump-rope': JumpRopeSvg,

  // Lat pull down
  lat_pull_down: LatPullDownSvg,
  'lat-pull-down': LatPullDownSvg,

  // Leg curl
  leg_curl: LegCurlSvg,
  'leg-curl': LegCurlSvg,

  // Leg extension
  leg_extension: LegExtensionSvg,
  'leg-extension': LegExtensionSvg,

  // Leg press
  leg_press: LegPressSvg,
  'leg-press': LegPressSvg,

  // Cable crossover
  new_crossover: CableCrossoverSvg,
  'new-crossover': CableCrossoverSvg,
  cable_crossover: CableCrossoverSvg,
  'cable-crossover': CableCrossoverSvg,

  // Pulley machine
  pulley_machine: PulleyMachineSvg,
  'pulley-machine': PulleyMachineSvg,

  // Seated row machine
  seated_row_machine: SeatedRowMachineSvg,
  'seated-row-machine': SeatedRowMachineSvg,

  // Shoulder press
  shoulder_press: ShoulderPressSvg,
  'shoulder-press': ShoulderPressSvg,

  // Triceps dip machine
  triceps_dip_machine: TricepsDipMachineSvg,
  'triceps-dip-machine': TricepsDipMachineSvg,

  // Yoga mat
  yoga_mat: YogaMatSvg,
  'yoga-mat': YogaMatSvg,

  // Bodyweight
  bodyweight: BodyweightSvg,
  'body-weight': BodyweightSvg,
  body_weight: BodyweightSvg,
  none: BodyweightSvg,

  // Pull up bar
  pull_up_bar: PullUpBarSvg,
  'pull-up-bar': PullUpBarSvg,

  // Resistance bands
  resistance_bands: ResistanceBandSvg,
  'resistance-bands': ResistanceBandSvg,
  resistance_band: ResistanceBandSvg,
  'resistance-band': ResistanceBandSvg,
};

export const getEquipmentIcon = (slugOrName: string): FC<SVGProps<SVGSVGElement>> => {
  if (!slugOrName) return OtherSvg;
  const normalized = slugOrName.toLowerCase().trim().replace(/\s+/g, '_');
  const normalizedHyphen = slugOrName.toLowerCase().trim().replace(/\s+/g, '-');
  return EQUIPMENT_ICON_MAP[normalized] || EQUIPMENT_ICON_MAP[normalizedHyphen] || OtherSvg;
};

export const EquipmentIcon: FC<{ slug: string; className?: string }> = ({ slug, className }) => {
  const SvgComponent = getEquipmentIcon(slug);
  return createElement(SvgComponent, { className });
};
